var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "title": "Filter Data",
      "ok-title": "Filter"
    },
    on: {
      "ok": _vm.fetchData
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "outline-secondary"
          },
          on: {
            "click": _vm.resetFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-undo mr-2"
        }), _vm._v(" Reset Filter ")]), _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancel")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v("Apply Filter")])];
      }
    }]),
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [[_c('FilterMaintenanceFormNew', {
    model: {
      value: _vm.filters,
      callback: function callback($$v) {
        _vm.filters = $$v;
      },
      expression: "filters"
    }
  })]], 2), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Maintenance History")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center mb-3"
        }, [_c('div', {
          staticClass: "d-flex px-3 align-items-center"
        }, [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _vm._v(" Filter Data ")])], 1), _c('div', {
          staticClass: "px-3"
        }, [_c('b-button-group', {
          attrs: {
            "size": "sm"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": _vm.viewMode === 'list' ? 'primary' : 'outline-primary',
            "title": "List View"
          },
          on: {
            "click": function click($event) {
              return _vm.setViewMode('list');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-list"
        })]), _c('b-button', {
          attrs: {
            "variant": _vm.viewMode === 'grid' ? 'primary' : 'outline-primary',
            "title": "Card View"
          },
          on: {
            "click": function click($event) {
              return _vm.setViewMode('grid');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-th-large"
        })])], 1)], 1)]), _vm.viewMode === 'list' ? _c('div', {
          staticClass: "table-responsive px-3 pb-4",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('table', {
          staticClass: "table align-middle table-striped table-hover"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', [_vm._v("Fleet Name")]), _c('th', [_vm._v("Fleet Type")]), _c('th', [_vm._v("Company")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Total Maintenance")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Active")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Overdue")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Postpone")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.paginatedData, function (vehicle, index) {
          var _vehicle$company;
          return _c('tr', {
            key: index
          }, [_c('td', [_c('span', {
            staticClass: "badge badge-success px-2 py-1"
          }, [_vm._v(" " + _vm._s(vehicle.name) + " ")])]), _c('td', [_vm._v(_vm._s(vehicle.vehicle_type_name))]), _c('td', [_vm._v(_vm._s((_vehicle$company = vehicle === null || vehicle === void 0 ? void 0 : vehicle.company) !== null && _vehicle$company !== void 0 ? _vehicle$company : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(vehicle.total_maintenance))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(vehicle.active))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(vehicle.overdue))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(vehicle.postpone))]), _c('td', {
            staticClass: "text-center"
          }, [_c('b-button', {
            attrs: {
              "variant": "outline-primary",
              "size": "sm"
            },
            on: {
              "click": function click($event) {
                return _vm.handleDetail(vehicle.id);
              }
            }
          }, [_vm._v(" Detail ")])], 1)]);
        }), 0)])]) : _c('div', {
          staticClass: "px-3 pb-4"
        }, [_c('div', {
          staticClass: "row"
        }, _vm._l(_vm.paginatedData, function (vehicle, idx) {
          var _vehicle$company2;
          return _c('div', {
            key: "card-".concat(idx),
            staticClass: "col-md-4 mb-4"
          }, [_c('div', {
            staticClass: "card shadow-sm h-100"
          }, [_c('div', {
            staticClass: "p-3"
          }, [_c('div', {
            staticClass: "card-image-placeholder"
          })]), _c('div', {
            staticClass: "card-body pt-0"
          }, [_c('h5', {
            staticClass: "card-title text-primary font-weight-bold mb-1"
          }, [_vm._v(" " + _vm._s(vehicle.name) + " "), _c('span', {
            staticClass: "ml-2 text-danger"
          }, [_vm._v("●")])]), _c('div', {
            staticClass: "text-muted small mb-2"
          }, [_vm._v(" " + _vm._s(vehicle.vehicle_type_name) + " • " + _vm._s((_vehicle$company2 = vehicle === null || vehicle === void 0 ? void 0 : vehicle.company) !== null && _vehicle$company2 !== void 0 ? _vehicle$company2 : '-') + " • Owned ")]), _c('div', {
            staticClass: "d-flex align-items-center justify-content-between bg-light p-2 mb-3",
            staticStyle: {
              "border-radius": "8px"
            }
          }, [_c('div', {
            staticClass: "text-muted d-flex align-items-center"
          }, [_c('i', {
            staticClass: "fa fa-info-circle mr-2 text-primary"
          }), _vm._v(" Total Plan Maintenance ")]), _c('div', {
            staticClass: "font-weight-bold text-black"
          }, [_vm._v(" " + _vm._s(vehicle.total_maintenance) + " Maintenance ")])]), _c('b-button', {
            attrs: {
              "block": "",
              "variant": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.handleDetail(vehicle.id);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-clipboard-list mr-2"
          }), _vm._v(" Detail Maintenance ")])], 1)])]);
        }), 0)]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between px-3 pb-2"
        }, [_c('div', [_c('span', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows : "), _c('strong', [_vm._v(_vm._s(_vm.totalRows))])])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.filters.limit,
            "first-number": "",
            "align": "center"
          },
          model: {
            value: _vm.filters.page,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "page", $$v);
            },
            expression: "filters.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.onChangeLimit
          },
          model: {
            value: _vm.filters.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "limit", $$v);
            },
            expression: "filters.limit"
          }
        })], 1)])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }